import axios from 'axios';

const axiosInstance = axios.create({
    //baseURL: 'https://api.allthatstats.com/',
    baseUrl: 'http://now.ats.dev',
});

axiosInstance.interceptors.response.use((response) => response, (error) => {
    let value = error.response;


    /*
    if (value.status === 401 && User.loggedIn()) {
        // renewToken performs authentication using username/password saved in sessionStorage/localStorage
        return User.refresh().then((response) => {
            if (response.data.token.length === 0) {
                // could not refresh
                User.logout();
                return;
            }
            User.setToken(response.data.token);
            error.config.baseURL = undefined; // baseURL is already present in url

            return axiosInstance.request(error.config);
        });
    }
     */

    return Promise.reject(error);
});

export default axiosInstance;
